import React, { useState, useCallback,  useRef } from "react";
import { connect } from "react-redux";
import { useLocation } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField'
import { useHistory } from 'react-router-dom';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { useParams } from 'react-router-dom';
import InvoiceHeaderDetailsTab from './InvoiceHeaderDetailsTab';

const searchpanel = [
    {
        ID: '1',
        Title: 'Search Filters'
    }
];
const initialFormFields = {
    Rowid: '',
    record: '',
    InvoiceNumber: '',
    TransactionType: '',
    R_CUSTOMER: '',
    InvoiceDate: '',
    ReferenceNumber: '',
    Description: '',
    STATUS: '',
    PRINTINVOICE: '',
    DueDate: '',
    Comment: '',
    FiscalYear: '',
    FiscalPeriod: '',
};
const Primarylayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "record",
                "tableName": "",
                "label": "Record #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "R_CUSTOMER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "om/SaleOrder/GetCustomers",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransactionType",
                "tableName": "",
                "label": "Type:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "InvoiceNumber",
                "tableName": "",
                "label": "Invoice #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "InvoiceDate",
                "tableName": "",
                "label": "Invoice Date:",
                "role": null,
                "isLabelChanged": false,
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "Description",
                "tableName": "",
                "label": "Description:",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ReferenceNumber",
                "tableName": "",
                "label": "Reference #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "STATUS",
                "tableName": "",
                "label": "Status:",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTINVOICE",
                "tableName": "",
                "label": "Print Invoice:",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "DueDate",
                "tableName": "",
                "label": "Due Date",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Comment",
                "tableName": "",
                "label": "Comment",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
            ,
            {
                "name": "FiscalYear",
                "tableName": "",
                "label": "Fiscal Year",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "FiscalPeriod",
                "tableName": "",
                "label": "Fiscal Period",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "Amount",
                "tableName": "",
                "label": "Amount",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
                
            }
        ]
    }

]

function UpdateInvoice(props) {
    var accessToken = props.oidc.user.access_token;
    const { id } = useParams();
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const history = useHistory();
    const goBack = () => {
        history.push("/wm/searchinvoices");
    };
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const location = useLocation();
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [dataSource, setDataSource] = useState(null);
    const [forceRender, setForceRender] = useState(false); // State variable to force re-render
    const [headerIdRowId, setHeaderIdRowId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const formRefs = useRef({});
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus(prevStatus => !prevStatus);
        },
        [selectedItems]
    );
    const UpdateTotalAmount = ()=>{
        GetOmTransactionHeader(id, "wm/UpdateInvoice/GetInvoiceById");
    }
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault()
            //console.log(formFields);
            const url = "wm/UpdateInvoice/UpdateInvoice";
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, formFields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.success) {

                const newRowId = response.data.rowId;
                setHeaderIdRowId(newRowId);
                setIsFormSubmitted(false);
                notify(
                    {
                        message: response.data.message,
                        width: 600,
                    },
                    'success',
                    3000,
                );
            } else {
                notify(
                    {
                        message: response.data.message,
                        width: 100,
                    },
                    'error',
                    3000,
                );
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const loadLookup = async (name, url) => {
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const responseData = response.data;
            if (responseData.success) {
                const newOptions = responseData.lookups.map(item => ({
                    id: item.rowid,
                    name: item.code
                }));
                //console.log('Current Options:', formRefs.current[name].instance().option('dataSource'));
                if (formRefs.current[name]) {
                    //console.log('found control:');

                    formRefs.current[name].instance().option('dataSource', newOptions);
                    formRefs.current[name].instance().option('valueExpr', 'id');
                    formRefs.current[name].instance().option('displayExpr', 'name');
                    setForceRender(!forceRender);
                } else {
                    //console.log('not found control:');

                }
            } else {

                //console.error('Failed to get item detail:');
            }
        } catch (error) {

            //console.error('Error fetching item detail:', error);
        } finally {
            /// setTimeout(hideLoadPanel, 1000);
        }
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const handleReset = () => {
        setformFields(initialFormFields);
    };
    const GetOmTransactionHeader = async (id, url) => {
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}?id=${id}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            const responseData = response.data;
            //console.error(responseData);
            if (responseData.success) {
                setformFields(prevFields => ({
                    ...prevFields,
                    Rowid: responseData.invoiceHeader.rowid,
                    record: responseData.invoiceHeader.record,
                    InvoiceNumber: responseData.invoiceHeader.invoiceNumber,
                    R_CUSTOMER: responseData.invoiceHeader.rCustomer,
                    TransactionType: responseData.invoiceHeader.transactionType,
                    InvoiceDate: responseData.invoiceHeader.invoiceDate,
                    Description: responseData.invoiceHeader.description,
                    ReferenceNumber: responseData.invoiceHeader.referenceNumber,
                    STATUS: responseData.invoiceHeader.status,
                    PRINTINVOICE: responseData.invoiceHeader.printInvoice,
                    DueDate: responseData.invoiceHeader.dueDate,
                    Comment: responseData.invoiceHeader.comment,
                    FiscalYear: responseData.invoiceHeader.fiscalYear,
                    FiscalPeriod: responseData.invoiceHeader.fiscalPeriod,
                    Amount: responseData.invoiceHeader.amount,
                }));
            } else {
                //console.error('Failed to get item detail:');
            }
        } catch (error) {
            //console.error('Error fetching item detail:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const handleFieldChange = useCallback((name, value) => {
        //console.log(name, value)
    }, []);
    const loadLookupClient = (name, data) => {

        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs.current[name]) {

                formRefs.current[name].instance().option('dataSource', newOptions);
                formRefs.current[name].instance().option('valueExpr', 'id');
                formRefs.current[name].instance().option('displayExpr', 'name');
                setForceRender(!forceRender);
            } else {
            }

        } catch (error) {
            //console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const handlePrimaryFormLoad = useCallback(() => {
        loadLookup("R_CUSTOMER", "om/SaleOrder/GetCustomers");
        GetOmTransactionHeader(id, "wm/UpdateInvoice/GetInvoiceById");
        var types = [{ "Rowid": "A", "Code": "All" }, { "Rowid": "C", "Code": "Storage" }, { "Rowid": "M", "Code": "Miscellaneous" }
            , { "Rowid": "R", "Code": "Receipt" }, { "Rowid": "S", "Code": "Shipment" }];
        loadLookupClient("TransactionType", types);
        var status = [{ "Rowid": "H", "Code": "Hold" }, { "Rowid": "L", "Code": "Ready To Commit Later" }, { "Rowid": "O", "Code": "Open" }
            , { "Rowid": "Z", "Code": "Committed" }];
        loadLookupClient("STATUS", status);
        var printStatus = [{ "Rowid": "N", "Code": "No" }, { "Rowid": "P", "Code": "Printed" }, { "Rowid": "Y", "Code": "Yes" }
        ];
        loadLookupClient("PRINTINVOICE", printStatus);
    }, []);
    return (
        <div className="row dataEntryMainPage">
            <div className="col-md-12 main-page">
                {location.pathname === '/om/history/view-history' ? (
                    <></>) : (
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={showIndicator}
                            shading={shading}
                            showPane={showPane}
                            hideOnOutsideClick={hideOnOutsideClick}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Update Invoices
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        type="default"
                                        className="accordianButton"
                                        disabled={isFormSubmitted || formFields.STATUS === 'Z'}
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="headerLastButton"  onClick={goBack} text="Back"/>
                                </Item>
                            </Toolbar>
                            <>
                                <div className="AccordionItemBody">
                                    <TabPanel className="TabpanelContainer">
                                        <TabItem title="Primary">
                                            <FormField
                                                currrentUser={currentUser}
                                                layoutId='90A86CFE-E534-4EE4-A7EE-BC4E4C42BAB2'
                                                layoutName='MyTestForm'
                                                defaultFormSchema={Primarylayout}
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                handleFieldValueChange={handleFieldChange}
                                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                                formRefs={formRefs}
                                                onFormLoad={handlePrimaryFormLoad}
                                            />

                                        </TabItem>

                                        <TabItem title="Details"   >
                                            <InvoiceHeaderDetailsTab
                                                headerId={id}
                                                UpdateTotalAmount={UpdateTotalAmount}
                                                formFields={formFields}
                                            />
                                        </TabItem>


                                    </TabPanel>
                                </div>


                                {/* </Item>
                        ))}
                      </DxTabPanel> */}
                            </>

                        </form>
                    </div>
                )}

            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UpdateInvoice);
